// @ts-ignore
import isPlainObject from 'lodash.isplainobject';

export class ResponseError extends Error {
  status: Nullable<number>;
  url: string;

  constructor(message: string = '', statusCode: Nullable<number> = null, url: string = '') {
    super(message);
    this.name = 'ResponseError';
    this.status = statusCode;
    this.url = url;
    Object.setPrototypeOf(this, ResponseError.prototype); // For more details see https://github.com/Microsoft/TypeScript/issues/13965
  }

  toString(): string {
    return `${super.toString()}, Status code: ${this.status}`;
  }

  static fromResponseData(responseText: string, status: number, url: string) {
    let responseError;

    const containsErrorsObject = function (data: any) {
      return isPlainObject(data) && data.errors && data.errors.length > 0;
    };

    const handleDataAsErrorsObject = function (data: any) {
      const { message } = data.errors[0];
      return new ResponseError(message, status, url);
    };

    const handleDataAsObject = function (data: any) {
      const message = JSON.stringify(data);
      return new ResponseError(message, status, url);
    };

    const handleDataAsString = function (data: string = '') {
      data = data ?? '';
      return new ResponseError('' + data, status, url);
    };

    try {
      const data = JSON.parse(responseText);
      if (containsErrorsObject(data)) {
        responseError = handleDataAsErrorsObject(data);
      } else if (isPlainObject(data)) {
        responseError = handleDataAsObject(data);
      } else {
        responseError = handleDataAsString(responseText);
      }
    } catch (e) {
      responseError = handleDataAsString(responseText);
    }

    return responseError;
  }
}
